<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../domain/callcenter/services'
  import * as Status from '../../../domain/usuarios/helpers/PessoaStatus'
  import { mapGetters } from 'vuex'
  import ACL from '../../../domain/acl/tmp-acl'
  import {GRV_ESPIRITO_SANTO} from '../../../domain/grv/helpers/tipos-grv'
  import tt from '@tomtom-international/web-sdk-maps'
  import TomServices from '@tomtom-international/web-sdk-services'

  export default {
    components: {},
    nome: 'solicitacao-remocao',
    directives: {mask},
    data () {
      return {
        api_key: 'MdpIjOOXGAuqUwtje2RgFCpZ7epTxGNV',
        data: null,
        isLoaded: true,
        loadMapEl: false,
        saLogs: [],
        showAtendenteReboquistaForm: false,
        patio: {
          lat: '-20.420874',
          lng: '-40.329344'
        },
        pointA: {
          lat: 0,
          lng: 0
        },
        pointB: {
          lat: 0,
          lng: 0
        },
        originTodestiny: {
          metros: 0,
          time: 0
        },
        destinyToorigin: {
          metros: 0,
          time: 0
        },
        map: null
      }
    },
    computed: {
      apiUrl () {
        return process.env.API_URL
      },
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      },
      kmIda () {
        return this.originTodestiny.metros !== 0 ? (this.originTodestiny.metros / 1000).toFixed(1) + ' KM' : '-'
      },
      kmVolta () {
        return this.destinyToorigin.metros !== 0 ? (this.destinyToorigin.metros / 1000).toFixed(1) + ' KM' : '-'
      },
      kmTotal () {
        return this.originTodestiny.metros !== 0 && this.destinyToorigin.metros !== 0 ? ((this.originTodestiny.metros + this.originTodestiny.metros) / 1000).toFixed(1) + ' KM' : '-'
      },
      timeIda () {
        return this.originTodestiny.time !== 0 ? Math.round(this.originTodestiny.time / 60) + ' minutos' : '-'
      },
      timeVolta () {
        return this.destinyToorigin.time !== 0 ? Math.round(this.destinyToorigin.time / 60) + ' minutos' : '-'
      },
      timeTotal () {
        return this.originTodestiny.time !== 0 && this.destinyToorigin.time !== 0 ? Math.round((this.originTodestiny.time + this.destinyToorigin.time) / 60) + ' minutos' : '-'
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados')
      service.find(this.$route.params.id)
        .then((response) => {
          console.log(response.data)
          this.$loaderOverlay.hide()
          this.data = response.data
          this.$nextTick(() => {
            this.map = tt.map({
              key: this.api_key,
              container: 'mapIn',
              style: 'tomtom://vector/1/basic-main',
              dragPan: true
            })
            this.map.addControl(new tt.FullscreenControl())
            this.map.addControl(new tt.NavigationControl())
            document.querySelector('.mapboxgl-control-container').style.display = 'none'
            if (this.data.latRecolhimento !== null && this.data.lngRecolhimento !== null) {
              this.$nextTick(() => {
                setTimeout(() => this.getRoute(), 2000)
              })
            }
          })
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      SolicitarReboque () {
        var data = this.data
        data.redirect = 558
        data.destinyToorigin = this.destinyToorigin
        this.$router.push({name: 'callcenter.main', query: data})
      },
      Status () {
        return Status
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      print: function () {
        window.print()
      },
      adjustFirstLetter (v) {
        return v.charAt(0).toLowerCase() + v.slice(1)
      },
      editar () {
        // this.$router.push({name: 'usuario.editar', params: {id: this.data.id}})
      },
      deletar () {
        // delete ?
      },
      criarGrv () {
        this.$router.push({name: 'grv.novo', query: {solicitacao: this.data.id, tipoGrv: GRV_ESPIRITO_SANTO}})
      },
      acessarLinkPublicoImagemCompleta (id) {
        this.$loaderOverlay.open()
        service.getPublicLinkS3(id)
          .then(response => {
            const link = document.createElement('a')
            link.href = response.data
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.$loaderOverlay.hide()
          })
          .catch(error => {
            alert('Ocorreu um erro ao acessar a imagem, tente novamente')
            this.$loaderOverlay.hide()
            console.log(error)
          })
      },
      getRoute () {
        var origin = this.data.patioDestino.longitude + ',' + this.data.patioDestino.latitude
        var destiny = this.data.lngRecolhimento + ',' + this.data.latRecolhimento
        console.log(origin, destiny)
        if (this.map.getLayer('route')) {
          this.map.removeLayer('route')
          this.map.removeSource('route')
        }
        // origin to destiny
        TomServices.services.calculateRoute({
          key: this.api_key,
          traffic: true,
          vehicleAdrTunnelRestrictionCode: 'D',
          language: 'pt-BR',
          locations: origin + ':' + destiny
        })
        .go()
        .then((response) => {
          console.log('origin to destiny', response)
          this.originTodestiny.metros = response.routes[0].summary.lengthInMeters
          this.originTodestiny.time = response.routes[0].summary.travelTimeInSeconds
          var geojson = response.toGeoJson()
          this.drawMap(geojson)
        })
        .catch((error) => {
          console.log(error)
          this.$loaderOverlay.hide()
          alert('Error no calculo de rota, verifique o endereço pesquisado!')
        })
        // destiny to origin
        setTimeout(() => {
          TomServices.services.calculateRoute({
            key: this.api_key,
            traffic: true,
            ehicleAdrTunnelRestrictionCode: 'D',
            language: 'pt-BR',
            locations: destiny + ':' + origin
          })
          .go()
          .then((res) => {
            console.log('destiny to origin', res)
            this.destinyToorigin.metros = res.routes[0].summary.lengthInMeters
            this.destinyToorigin.time = res.routes[0].summary.travelTimeInSeconds
          })
          .then(() => {
            this.$loaderOverlay.hide()
          })
          .catch((error) => {
            console.log(error)
            this.$loaderOverlay.hide()
          })
        }, 1000)
      },
      createMarkerElement (type) {
        var element = document.createElement('div')
        var innerElement = document.createElement('div')

        element.className = 'route-marker'
        innerElement.className = 'icon this.tt-icon -white -' + type
        element.appendChild(innerElement)
        return element
      },
      addMarkers (feature) {
        var startPoint, endPoint
        if (feature.geometry.type === 'MultiLineString') {
          startPoint = feature.geometry.coordinates[0][0] // get first point from first line
          endPoint = feature.geometry.coordinates.slice(-1)[0].slice(-1)[0] // get last point from last line
        } else {
          startPoint = feature.geometry.coordinates[0]
          endPoint = feature.geometry.coordinates.slice(-1)[0]
        }
        new tt.Marker({ element: this.createMarkerElement('start') }).setLngLat(startPoint).addTo(this.map)
        new tt.Marker({ element: this.createMarkerElement('finish') }).setLngLat(endPoint).addTo(this.map)
      },
      findFirstBuildingLayerId () {
        var layers = this.map.getStyle().layers
        for (var index in layers) {
          if (layers[index].type === 'fill-extrusion') {
            return layers[index].id
          }
        }
        throw new Error('O estilo de mapa não contém nenhuma camada com tipo de extrusão de preenchimento.')
      },
      drawMap (geojson) {
        this.map.addLayer({
          'id': 'route',
          'type': 'line',
          'source': {
            'type': 'geojson',
            'data': geojson
          },
          'paint': {
            'line-color': '#4a90e2',
            'line-width': 6
          }
        }, this.findFirstBuildingLayerId())
        this.addMarkers(geojson.features[0])
        var bounds = new tt.LngLatBounds()
        geojson.features[0].geometry.coordinates.forEach((point) => {
          bounds.extend(tt.LngLat.convert(point))
        })
        this.map.fitBounds(bounds, { duration: 0, padding: 50 })
        this.$loaderOverlay.hide()
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="data !== null" class="content-transition">
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-3">
              <!--<h1 class="m-n font-thin h3">#{{ data.apelido }}</h1>
              <h1 class="m-n font-thin h3">{{ data.pessoa.nome }}</h1>-->
              <h1 class="m-n font-thin h3">Solicitação de Remoção</h1>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success"></span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-9">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print"><i class="fa fa-print m-r-xs"></i> Imprimir
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs hidden-print m-r" tabindex="1"
                        @click.prevent="criarGrv"><i class="fa fa-file m-r-xs"></i> Criar GRV para esta solicitação
              </u-button>
              <u-button class="btn btn-sm btn-primary pull-right pull-none-xs hidden-print m-r" tabindex="1"
                        @click.prevent="SolicitarReboque"><i class="fa fa-car m-r-xs"></i>Iniciar Atendimento
              </u-button>
              <router-link :to="{name: 'solicitacoes-remocao'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>

        <div ref="mapIn" id="mapIn" class="map"></div>
        <div class="row wrapper-md">
          <div class="col-sm-2 label-info">
            <span>Deslocamento Ida :</span>
          </div>
          <div class="col-sm-2">
            <span>{{kmIda}} / {{timeIda}}</span>
          </div>
          <div class="col-sm-2 label-info">
            <span>Deslocamento Volta :</span>
          </div>
          <div class="col-sm-2">
            <span>{{kmVolta}} / {{timeVolta}}</span>
          </div>
          <div class="col-sm-2 label-info">
            <span>Deslocamento Total :</span>
          </div>
          <div class="col-sm-2">
            <span>{{kmTotal}} / {{timeTotal}}</span>
          </div>
        </div>

        <div class="wrapper-md">


          <div class="row">
            <div class="col-xs-6">
              <h4>Solicitação nº #{{ data.id }}</h4>
              <p>Placa: {{ data.placa || '-' }}</p>
              <p>Veículo: {{ data.nomeVeiculo || '-' }}</p>

              <p>
                <span v-for="grv in data.grvs">GRV: {{ grv.numero }}<br></span>
              </p>
              <p>
                Agente: <span>{{ data.nomeAgente  }}</span>
              </p>
              <p>
                Tipo de Veículo: <span>{{ data.categoria ? data.categoria.nome : '-'  }}</span>
              </p>
              <p>
                Pátio de Destino: <span>{{ data.patioDestino ? data.patioDestino.nome : '-'  }}</span>
              </p>
              <p>
                Endereço de Recolhimento: <span>{{ data.enderecoRecolhimento || '-'  }}</span><br>
                Latitude: <span>{{ data.latRecolhimento || '-'  }}</span><br>
                Longitude: <span>{{ data.lngRecolhimento || '-'  }}</span><br>
              </p>
              <p v-if="data.observacoes">
                Observações:<br><br>
                {{ data.observacoes }}
              </p>
            </div>
            <div class="col-xs-6 text-right text-left-print">
              <p class="h4">#{{ data.id }}</p>
              <h5>Data de Início: {{ moment(data.dataInicio && data.dataInicio.date).format('L LTS') }}</h5>
              <h5>Início do Recolhimento: {{ data.dataInicioRecolhimento && moment(data.dataInicioRecolhimento.date).format('L LTS') }}</h5>
              <h5>Início do Transporte: {{ data.dataInicioTransporte && moment( data.dataInicioTransporte.date).format('L LTS') }}</h5>
              <h5>Entrega: {{ data.dataEntrega && moment( data.dataEntrega.date).format('L LTS') }}</h5>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="m-b m-t-lg">Fotos</div>
              <div class="fotos-flex" v-if="data.fotos && data.fotos.length">
                <div v-for="(foto, index) in data.fotos" :id="'solic-foto-' + foto.id" class="foto">
                  <a @click="acessarLinkPublicoImagemCompleta(foto.id)">
                    <img :src="foto.imageInfo && foto.imageInfo.min.url" class="img-responsive">
                  </a>
                  <div style="font-size: 11px">
                  <div>Foto registrada {{foto.storageCreatedAt.date|formatDate('DD/MM/YYYY HH:mm:s')}}</div>
                  <div>GPS: Lat: {{String(foto.gps.lat)}}, Lng: {{String(foto.gps.lng)}}</div>
                  </div>
                </div>
              </div>
              <div v-else>Nenhuma foto cadastrada</div>
            </div>
          </div>

          <br><br><br>

        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
  .map{
    display: flex;
    width: 100%;
    height: 40vh;
  }
  .mapboxgl-control-container{
    display: none;
  }
  .label-info{
    font-size: 16px;
    font-weight: bold;
    color: white;
  }
  @media (max-width: 768px){
    .btn-search{
      margin-top: 10px;
      float: right;
    }
  }
</style>




// WEBPACK FOOTER //
// VisualizarSolicitacao.vue?4c35078f